var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1717.18 1245.55V790.69C1717.18 783.085 1712.71 776.2 1705.76 773.11L868.342 400.907C855.622 395.252 841.289 404.567 841.289 418.487V1245.54C841.289 1256.17 849.899 1264.78 860.527 1264.78H1697.95C1708.57 1264.78 1717.18 1256.17 1717.18 1245.54V1245.55Z",
    stroke: "url(#paint0_linear_909_58589)",
    strokeWidth: 1.59,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.98 173.822V628.682C1056.98 636.287 1061.46 643.172 1068.4 646.262L1905.82 1018.46C1918.54 1024.11 1932.88 1014.8 1932.88 1000.88V173.822C1932.88 163.195 1924.27 154.585 1913.64 154.585H1076.22C1065.59 154.585 1056.98 163.195 1056.98 173.822Z",
    stroke: "url(#paint1_linear_909_58589)",
    strokeWidth: 1.59,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.33 1403.75V948.895C1093.33 941.29 1088.86 934.405 1081.91 931.315L244.49 559.113C231.77 553.458 217.438 562.772 217.438 576.692V1403.75C217.438 1414.37 226.048 1422.99 236.675 1422.99H1074.1C1084.72 1422.99 1093.33 1414.37 1093.33 1403.75V1403.75Z",
    stroke: "url(#paint2_linear_909_58589)",
    strokeWidth: 1.59,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-201.063 -351.763V103.098C-201.063 110.703 -196.585 117.587 -189.64 120.677L647.78 492.872C660.5 498.527 674.832 489.213 674.832 475.293V-351.763C674.832 -362.39 666.222 -371 655.595 -371H-181.833C-192.46 -371 -201.07 -362.39 -201.07 -351.763H-201.063Z",
    stroke: "url(#paint3_linear_909_58589)",
    strokeWidth: 1.59,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-406 -19.1297V435.73C-406 443.335 -401.523 450.22 -394.578 453.31L442.843 825.505C455.563 831.16 469.895 821.845 469.895 807.925V-19.1297C469.895 -29.7572 461.285 -38.3672 450.657 -38.3672H-386.763C-397.39 -38.3672 -406 -29.7572 -406 -19.1297V-19.1297Z",
    stroke: "url(#paint4_linear_909_58589)",
    strokeWidth: 1.59,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_909_58589",
    x1: 849.089,
    y1: 1262.16,
    x2: 1523.28,
    y2: 587.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D189F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9222FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF0CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_909_58589",
    x1: 1933.48,
    y1: 587.365,
    x2: 1056.38,
    y2: 587.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D189F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9222FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF0CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_909_58589",
    x1: 216.845,
    y1: 990.22,
    x2: 1093.93,
    y2: 990.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D189F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9222FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF0CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_909_58589",
    x1: 675.425,
    y1: 61.7725,
    x2: -201.663,
    y2: 61.7725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D189F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9222FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF0CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_909_58589",
    x1: -181.127,
    y1: -160.767,
    x2: 406.19,
    y2: 856.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D189F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9222FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF0CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLines);
export default __webpack_public_path__ + "static/media/bg_lines.b9eb16447bce993b6bb8fb74e9ded29c.svg";
export { ForwardRef as ReactComponent };